module.exports = __webpack_public_path__ + "static/images/53b835f2f2651ad4ff957389f668dd79.png";